import { api } from './client';
import type { AuditAction, AuditLogEntry, AuditSource, ISODateTime, Page, UUID } from './types';

export interface AuditListParams {
  entity_type?: string; entity_id?: string;
  /** #47 follow-up (2026-06-12): actor / action / source are multi-select
   *  (C-132 Amendment 3, repeated query keys); ts_from / ts_to are
   *  calendar-day inclusive (UTC date) for the Timestamp header filter.
   *  since/until (exact datetimes) remain for API callers. */
  actor_user_id?: UUID[]; action?: AuditAction[]; source?: AuditSource[];
  since?: ISODateTime; until?: ISODateTime;
  ts_from?: string; ts_to?: string;
  limit?: number; offset?: number;
}
function qs(p: object): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) {
    if (v === undefined || v === null || v === '') continue;
    // Arrays expand to repeated query keys (FastAPI list parsing).
    if (Array.isArray(v)) {
      for (const item of v) {
        if (item !== undefined && item !== null && item !== '') u.append(k, String(item));
      }
    } else {
      u.set(k, String(v));
    }
  }
  return u.toString() ? `?${u}` : '';
}
/** Phase H0 #118 — extraction-activity summary, admin-only. */
export interface ExtractionSummaryUser {
  user_id: UUID;
  email: string;
  total_reads_ok: number;
  total_reads_blocked: number;
  by_entity_type: Record<string, number>;
  p50_reads_per_day: number;
  max_reads_per_day: number;
  anomaly_ratio: number;
}

export interface ExtractionSummary {
  window_days: number;
  generated_at_utc: ISODateTime;
  users: ExtractionSummaryUser[];
}

export const auditApi = {
  list: (p: AuditListParams = {}) => api.get<Page<AuditLogEntry>>(`/audit${qs(p)}`),
  extractionSummary: (days: number = 30) =>
    api.get<ExtractionSummary>(`/audit/extraction-summary?days=${days}`),
};
